import {AutoComplete} from "../openings/AutoComplete";
import {api} from "../../../../api/API";
import {Opening} from "../../../../api/Openings";
import {useProjectId} from "../ProjectName";
import {css} from "@emotion/css";
import {grey} from "@mui/material/colors";
import {useIsQuote} from "../../quote/QuoteContainer";
import {QuoteOpening} from "../../../../api/QuoteOpenings";
import {useAlternative} from "../../quote/alternative/Alternative";
import {contains} from "nate-react-api-helpers";

export function OpeningLookup(props: {
    onSelect(value: Opening|QuoteOpening): void;
    onMultiSelect(value: (Opening|QuoteOpening)[]): void;
    ignore: number[]
    backgroundColor?: string;
    hwGroup: number;
}) {
    if(!props.hwGroup) {
        return <div style={{fontWeight: "normal", color: grey["600"]}}>Save group to add more openings</div>
    }

    return (
        <OpeningLookupGeneric
            searchParams={{
                hwGroup: props.hwGroup,
                type: "add-hw-find-opening-number",
            }}
            ignore={props.ignore}
            onSelect={props.onSelect}
            onMultiSelect={props.onMultiSelect}
            backgroundColor={props.backgroundColor}
            placeholder="Enter opening number to add to group"
        />
    )
}

type OpeningParams = Parameters<typeof api.openings.list>[0];
type QuoteOpeningParams = Parameters<typeof api.quoteOpenings.list>[0];

export function OpeningLookupGeneric(props: {
    onSelect(value: Opening|QuoteOpening): void;
    onMultiSelect(value: (Opening|QuoteOpening)[]): void;
    ignore: number[]
    backgroundColor?: string;
    placeholder?: string;
    searchParams?: Partial<Pick<OpeningParams, keyof OpeningParams & keyof QuoteOpeningParams>>
}) {
    const project = useProjectId();
    const isQuote = useIsQuote();
    const alternative = useAlternative();

    return (
        <AutoComplete<Opening|QuoteOpening>
            search={async (search) => {
                if(isQuote) {
                    const rs = await api.quoteOpenings.list({
                        project: project,
                        search: search,
                        alternative: alternative,
                        ...(props.searchParams as any),
                    })

                    return rs.data.filter(d => !contains(props.ignore, d.id))
                }

                const rs = await api.openings.list({
                    project: project,
                    search: search,
                    ...props.searchParams,
                })

                return rs.data.filter(d => !contains(props.ignore, d.id))
            }}
            className={lookupClass}
            popperClassName={popperClass}
            value={null}
            equals={(a, b) => a.id === b.id}
            makeLabel={a => a.name}
            onSelect={props.onSelect}
            onMultiSelect={props.onMultiSelect}
            useNativeInput
            placeholder={props.placeholder}
            style={{
                backgroundColor: props.backgroundColor,
            }}
        />
    )
}

export const popperClass = css({
    "& .MuiMenuItem-root": {
        fontSize: "0.8rem",
    }
})

export const lookupClass = css({
    fontSize: "0.8rem",
    marginLeft: -4,

    "&::placeholder": {
        color: grey["500"],
        fontStyle: "italic",
    }
})